import React from 'react';
import * as rmd from 'material-ui';
import _ from 'lodash';
import { Link } from 'react-router';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';

const TemplateCard = ({ template, handleTemplatesHide, handleDialogOpen }) => (
    <rmd.Card className="theme-template">
        <div
            className={`theme__theme-colors widget-img`}
            style={{
                position: 'relative',
                backgroundSize: 'cover',
                backgroundImage: `url('${_.get(
                    template,
                    'theme.layers[0].backgroundImage'
                )}')`
            }}
        >
            <span
                style={{
                    position: 'absolute',
                    padding: '20px',
                    top: '50%',
                    left: '50%',
                    minWidth: '150px',
                    transform: 'translate(-50%, -50%)',
                    backgroundColor: template.theme.content.backgroundColor,
                    textAlign: 'center',
                    color: template.theme.color
                }}
            >
                {template.name}
            </span>
            <rmd.IconMenu
                iconButtonElement={
                    <rmd.IconButton>
                        <MoreVertIcon color={`${template.theme.color}`} />
                    </rmd.IconButton>
                }
                menuStyle={{ zIndex: 10001, position: 'relative' }}
                style={{
                    zIndex: 10001,
                    position: 'absolute',
                    top: '0',
                    right: '0'
                }}
                anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                targetOrigin={{ horizontal: 'right', vertical: 'top' }}
            >
                <rmd.MenuItem
                    primaryText={template.isHidden ? 'Show' : 'Hide'}
                    onClick={e => handleTemplatesHide(template.id)}
                />
                <rmd.MenuItem
                    primaryText='Clone'
                    onClick={handleDialogOpen('openCloneDialog', {cloneTemplateId: template.id})}
                />
            </rmd.IconMenu>
            <rmd.CardActions
                style={{
                    position: 'absolute',
                    left: '0',
                    right: '0',
                    bottom: '0',
                    padding: '0',
                    border: '0',
                    display: 'flex',
                    justifyContent: 'space-between',
                    flexDirection: 'row-reverse'
                }}
            >
                <Link
                    style={{
                        margin: '0',
                        backgroundColor: template.theme.content.backgroundColor,
                        color: template.theme.color
                    }}
                    onClick={window.location.reload}
                    to={`/sm/templates/edit?tid=${template.id}`}
                >
                    <rmd.FlatButton
                        labelStyle={{ color: '#fff' }}
                        className="create"
                        label="Edit"
                        primary
                    />
                </Link>
            </rmd.CardActions>
        </div>
    </rmd.Card>
);

export default TemplateCard;



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/TemplateCard.js
 **/